import ThemeToggle from '../theme_toggle';

new ThemeToggle();
